var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sans antialiased text-gray-800 h-screen w-screen overflow-hidden",attrs:{"id":"app"}},[(!_vm.isAuthRoute)?_c('Layout',[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }